import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.857 1.84v8.917l-.524 2.843a2.05 2.05 0 0 1-2.887 1.548 2.101 2.101 0 0 1-1.193-2.258l.4-2.14h-3.11a1.901 1.901 0 0 1-1.43-.62 2.132 2.132 0 0 1-.52-1.69l.4-4.71a2.1 2.1 0 0 1 2.09-1.89h6.774Zm3.476 0a.76.76 0 0 1 .75.76v7.37a.75.75 0 0 1-.75.75h-2.476V1.84h2.476Z';
const draw24px =
  'M15.955 16.345h.009v.005l-.63 3.76a2.671 2.671 0 0 1-2.63 2.29 2.75 2.75 0 0 1-2.72-3.2l.47-2.8h-5.12a2.441 2.441 0 0 1-1.84-.8 2.84 2.84 0 0 1-.68-2.27l.6-7a2.751 2.751 0 0 1 2.73-2.48h9.811v12.495ZM21.333 3.85a.75.75 0 0 1 .75.75v11a.743.743 0 0 1-.217.533.74.74 0 0 1-.533.217h-3.869v-2.38h-.009V3.85h3.878Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ThumbsDownFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'thumbsDownFilledIcon')) as IconWithRender;

ThumbsDownFilledIcon.displayName = 'ThumbsDownFilledIcon';
ThumbsDownFilledIcon.propTypes = Icon.propTypes;
ThumbsDownFilledIcon.renderIcon = (props) => (
  <ThumbsDownFilledIcon {...props} />
);
export default ThumbsDownFilledIcon;
